export function getDecimalSeparators(replacePoint) {
    if (typeof replacePoint === 'boolean' && replacePoint) {
        return { 'ToReplace': '.', 'ReplaceWith': ',' };
    } else {
        return { 'ToReplace': ',', 'ReplaceWith': '.' };
    }
}

export function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}